module.exports = __webpack_public_path__ + "static/media/portfolio01.d069dd77.jpg";